import { render, staticRenderFns } from "./Selecter.vue?vue&type=template&id=4d78540a&scoped=true&"
import script from "./Selecter.vue?vue&type=script&lang=js&"
export * from "./Selecter.vue?vue&type=script&lang=js&"
import style0 from "./Selecter.vue?vue&type=style&index=0&id=4d78540a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d78540a",
  null
  
)

export default component.exports